import React from 'react';
import { NavbarElementProps } from 'react-day-picker';
import { makeStyles, Theme } from '@material-ui/core/styles';

import { IconButton, units } from '@ha/dsl';

import ArrowButtonLeft from 'streamline-icons/arrow-button-left-bold.svg';
import ArrowButtonRight from 'streamline-icons/arrow-button-right-bold.svg';

const useStyles = makeStyles((theme: Theme) => ({
  leftButton: {
    zIndex: 1,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.grey[600],
    position: 'absolute',
    top: units.rem(1.4),
    [theme.breakpoints.up('sm')]: {
      left: units.rem(0.8),
    },
  },
  rightButton: {
    zIndex: 1,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.grey[600],
    position: 'absolute',
    top: units.rem(1.4),
    right: units.rem(0),
    [theme.breakpoints.up('sm')]: {
      right: units.rem(0.8),
    },
    left: 'auto',
  },
}));

type OwnProps = NavbarElementProps;

const NavBar: React.FC<OwnProps> = props => {
  const classes = useStyles();
  const { onPreviousClick, onNextClick } = props;

  return (
    <div data-test-locator="DatePicker/Calendar/NavBar">
      <IconButton
        className={classes.leftButton}
        onClick={() => onPreviousClick()}
        data-test-locator="DatePicker/Calendar/NavBar/PrevArrow"
      >
        <ArrowButtonLeft fontSize="small" />
      </IconButton>
      <IconButton
        className={classes.rightButton}
        onClick={() => onNextClick()}
        data-test-locator="DatePicker/Calendar/NavBar/NextArrow"
      >
        <ArrowButtonRight fontSize="small" />
      </IconButton>
    </div>
  );
};

export default React.memo(NavBar);
